/* eslint-disable */
const protobufPackageSarasa = "decentraland.sdk.components.common";
/**
 * @public
 */
export var MediaState;
(function (MediaState) {
    MediaState[MediaState["MS_NONE"] = 0] = "MS_NONE";
    MediaState[MediaState["MS_ERROR"] = 1] = "MS_ERROR";
    MediaState[MediaState["MS_LOADING"] = 2] = "MS_LOADING";
    MediaState[MediaState["MS_READY"] = 3] = "MS_READY";
    MediaState[MediaState["MS_PLAYING"] = 4] = "MS_PLAYING";
    MediaState[MediaState["MS_BUFFERING"] = 5] = "MS_BUFFERING";
    MediaState[MediaState["MS_SEEKING"] = 6] = "MS_SEEKING";
    MediaState[MediaState["MS_PAUSED"] = 7] = "MS_PAUSED";
})(MediaState || (MediaState = {}));
